import ApiService from '../../../shared/services/api-service';
import commonActions from '../../../shared/store/common/action-creators';
import notificationsActionsCreators from '../notifications/action-creators';
import notesCommitTypes from './commit-types';

const notesActionsCreators = {
  addNote(reportGuid) {
    return {
      addingNoteFor: reportGuid,
      type: notesCommitTypes.SET_ADDING_NOTE_FOR,
    };
  },
  closeAddNote() {
    return {
      addingNoteFor: null,
      type: notesCommitTypes.SET_ADDING_NOTE_FOR,
    };
  },
  closeEditNote() {
    return {
      isEditingNote: null,
      type: notesCommitTypes.SET_IS_EDITING_NOTE,
    };
  },
  createNote(formData) {
    const post = { ...formData };
    // Remove redundant
    delete post.reportGuid;
    return async (dispatch) => {
      dispatch(this.setIsLoading('createNote'));
      const data = await ApiService.post(`/api/v1/reports/${formData.reportGuid}/notes`, post)
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(this.setIsLoading('createNote'));
      if (data.error) {
        commonActions.handleApiError(data.error);
      } else {
        dispatch(this.createNoteSuccess(data));
      }
    };
  },
  createNoteSuccess(created) {
    return (dispatch) => {
      dispatch(this.pushNote(created.data));
      dispatch(this.closeAddNote());
      dispatch(notificationsActionsCreators.addSavedSuccessfully('Note created'));
    };
  },
  deleteNote(noteGuid) {
    return async (dispatch) => {
      dispatch(this.setIsLoading('deleteNote'));
      const data = await ApiService.delete(`/api/v1/notes/${noteGuid}`)
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(this.setIsLoading('deleteNote'));
      if (data.error) {
        commonActions.handleApiError(data.error);
      } else {
        dispatch(this.deleteNoteSuccess(data));
      }
    };
  },
  deleteNoteSuccess(deleted) {
    return (dispatch) => {
      dispatch(this.removeNote(deleted.data));
      dispatch(notificationsActionsCreators.addSavedSuccessfully('Note deleted'));
    };
  },
  editNote(noteGuid) {
    return {
      isEditingNote: noteGuid,
      type: notesCommitTypes.SET_IS_EDITING_NOTE,
    };
  },
  pushNote(note) {
    return {
      note,
      type: notesCommitTypes.PUSH_NOTE,
    };
  },
  pushNotes(notes) {
    return {
      notes,
      type: notesCommitTypes.PUSH_NOTES,
    };
  },
  removeNote(deleted) {
    return {
      noteGuid: deleted.guid,
      type: notesCommitTypes.REMOVE_NOTE,
    };
  },
  replaceNote(note) {
    return {
      note,
      type: notesCommitTypes.REPLACE_NOTE,
    };
  },
  resetNoteState() {
    return {
      type: notesCommitTypes.RESET_NOTE_STATE,
    };
  },
  setIsLoading(isLoading) {
    return {
      isLoading,
      type: notesCommitTypes.SET_NOTES_IS_LOADING,
    };
  },
  updateNote(formData) {
    const patch = { ...formData };
    // Remove redundant
    delete patch.reportGuid;
    return async (dispatch) => {
      dispatch(this.setIsLoading('updateNote'));
      const data = await ApiService.patch(`/api/v1/notes/${formData.noteGuid}`, patch)
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(this.setIsLoading('updateNote'));
      if (data.error) {
        commonActions.handleApiError(data.error);
      } else {
        dispatch(this.updateNoteSuccess(data));
      }
    };
  },
  updateNoteSuccess(updated) {
    return (dispatch) => {
      dispatch(this.replaceNote(updated.data));
      dispatch(this.closeEditNote());
      dispatch(notificationsActionsCreators.addSavedSuccessfully('Note updated'));
    };
  },
};

export default notesActionsCreators;
